import { useEffect } from "react";

export const useTrigger = <Trigger>(trigger: Trigger, triggerCallback: VoidFunction | VoidFuncAsync) => {
  useEffect(() => {
    trigger && triggerCallback();
  }, [trigger]);
};
